export function concatenateAnalyticsColours(
  source: string[],
  indicator: string
) {
  if (
    source.includes(`${indicator}|amber`) &&
    source.includes(`${indicator}|red`)
  ) {
    source = source.filter(
      (e) => e !== `${indicator}|amber` && e !== `${indicator}|red`
    );
    source.push(`${indicator}|red-amber`);
  }

  return source;
}

export const analyticsFormatType = {
  Standard: "assured",
  ElectricHybrid: "ev_hybrid",
  EssentialChecks: "essential",
  FullInspection: "128",
  NoReport: "none",
};

export const getAnalyticsPageVariant = ( vdr: string | string[] ) => vdr === "vp" ? "vendor" : "buyer";